import { useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import BaseLayout from "../../layouts/BaseLayout/BaseLayout";
import { AnswersContext } from "../../store/AnswersContext/AnswersContext";
import QuestionChart from "../../components/QuestionChart/QuestionChart";

export default function ToolDetail() {
  const { toolSlug } = useParams();
  const { answerData } = useContext(AnswersContext);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    loadQuestions();
  }, [toolSlug]);

  const loadQuestions = async () => {
    try {
      const response = await fetch("/assets/data/tools_questions.json");
      const json = await response.json();
      const section = json?.[toolSlug];

      if (Array.isArray(section)) {
        const flatQuestions = section.flat();
        setQuestions(flatQuestions);
      } else {
        console.warn(`⚠️ Nessuna sezione trovata per tool "${toolSlug}"`);
      }
    } catch (error) {
      console.error("❌ Errore nel caricamento del JSON:", error);
    }
  };

  const getAnswersForQuestion = (question) => {
    const counts = {};

    answerData.forEach((entry) => {
      const sectionAnswers = entry?.[`Tool${toolSlug}`];
      if (!sectionAnswers) return;

      const answersArray = Array.isArray(sectionAnswers)
        ? sectionAnswers
        : [sectionAnswers];

      answersArray.forEach((answerObj) => {
        if (String(answerObj.Question) !== String(question.number)) return;

        switch (question.type) {
          case "multislider":
            if (
              Array.isArray(answerObj.Sliders) &&
              Array.isArray(question.labels)
            ) {
              question.labels.forEach((label, index) => {
                const value = answerObj.Sliders[index] || 0;
                if (typeof value === "number") {
                  if (!counts[label]) counts[label] = [];
                  counts[label].push(value);
                }
              });
            }
            break;
          case "dual_counter":
            if (
              Array.isArray(answerObj.Sliders) &&
              answerObj.Sliders.length === 2
            ) {
              const key = `${answerObj.Sliders[0]}-${answerObj.Sliders[1]}`;
              counts[key] = (counts[key] || 0) + 1;
            }
            break;
          default:
            const key = String(answerObj.Answer).trim();
            if (key) counts[key] = (counts[key] || 0) + 1;
        }
      });
    });

    return counts;
  };

  return (
    <BaseLayout>
      <h2 className="text-xl font-semibold my-6">
        Tool {toolSlug}: Answer Breakdown
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {questions.map((question, index) => {
          const rawData = getAnswersForQuestion(question);
          const hasAnswers = rawData && Object.keys(rawData).length > 0;

          return (
            <div
              key={index}
              className="bg-white p-4 rounded-lg border border-gray-200 flex flex-col justify-between"
            >
              <h3 className="text-md font-semibold mb-2">
                {question.question}
              </h3>
              {hasAnswers ? (
                <QuestionChart
                  type={question.type}
                  question={question}
                  data={rawData}
                  index={index}
                />
              ) : (
                <p className="text-sm text-gray-500">No answers available</p>
              )}
            </div>
          );
        })}
      </div>
    </BaseLayout>
  );
}